import type { InvalidError } from "@thalamos/common";
import { mustParseAny } from "@thalamos/common";
import type {
  Section12DoctorSearchResult,
  Section12DoctorSearchResultUnbranded,
} from "@thalamos/aspire-common";
import { Section12DoctorSearchResultSchema } from "@thalamos/aspire-common";

const parseDoctorSearchResult = mustParseAny(
  Section12DoctorSearchResultSchema,
  "Doctor search result is not readable",
);

/**
 * The search payload split into the doctors the dialog can work on and the
 * ones it cannot, in the order they arrived.
 *
 * A doctor is kept whole or not at all: availability that cannot be read must
 * not be offered on the part that could. The caller reports `unreadable`; this
 * stays pure so it can run inside a memo.
 */
export function parseDoctorSearchResults(
  results: readonly Section12DoctorSearchResultUnbranded[],
): {
  doctors: Section12DoctorSearchResult[];
  unreadable: { doctorId: string; error: InvalidError }[];
} {
  const doctors: Section12DoctorSearchResult[] = [];
  const unreadable: { doctorId: string; error: InvalidError }[] = [];
  for (const result of results) {
    parseDoctorSearchResult(result).match(
      (doctor) => doctors.push(doctor),
      (error) => unreadable.push({ doctorId: result.id, error }),
    );
  }
  return { doctors, unreadable };
}
